import axios from "axios";
import { API_URL } from "../../lib/const";
import { getAxiosConfig } from "../../lib/auth";

export const searchEnrollments = (search) =>
  axios
    .get(`${API_URL}/onboarding/enrollments/search`, {
      ...getAxiosConfig(),
      params: { search },
    })
    .then((res) => res.data);

export const transferDocuments = (origemId, destinoId) =>
  axios
    .post(
      `${API_URL}/onboarding/enrollments/transfer_documents`,
      { origem_id: origemId, destino_id: destinoId },
      getAxiosConfig()
    )
    .then((res) => res.data);
